module.exports = __webpack_public_path__ + "img/Symfony.ee9cae2b.png";